import React from 'react';

function CounselingAccordion({
  classFirstCol,
  handleSubDataShow,
  parent,
  handleClick,
  accord,
  moduleName,
  handleAllWnl,
  popupName,
  unHide = '',
  editModeEnabled = false,
  editCategory = () => {},
  handleDeleteCategory = () => {},
  handleAddSubCategory = () => {},
  handleEditSubCategory = () => {},
  handleDeleteSubCategory = () => {},
}) {
  return (
    <div className="accordion pop-up-sb-hdr">
      <span
        className="flex-sec cnslng-frm-mn-hdr"
        style={{
          display: ' flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <span
          style={{
            display: ' flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
          }}
          onClick={() => handleClick(parent[3])}
        >
          <span className="cnslng-acrdn-arw">
            {accord === parent[3] ? (
              <div dangerouslySetInnerHTML={{ __html: '&#9660;' }} />
            ) : (
              <div dangerouslySetInnerHTML={{ __html: '&#9658;' }} />
            )}
          </span>
          <span className="cnslng-acrdn-txt">
            <div>{parent[1]}</div>
            {parent[4] !== 'medication' && parent[4] !== 'diagnosis' && (
              <div className={editModeEnabled ? '' : 'hide'}>
                <span
                  className="cnslng-icn-bg right showTemplate"
                  title="Update category"
                  style={{
                    padding: '0px 5px',
                    cursor: 'pointer',
                    display: 'inline-block',
                  }}
                  onClick={() =>
                    editCategory({
                      id: parent[0],
                      labelName: parent[1],
                      catagory: parent[3],
                    })
                  }
                >
                  ✎
                </span>
                <span
                  className="cnslng-icn-bg right showTemplate"
                  title="Add Sub category"
                  style={{
                    padding: '0px 5px',
                    cursor: 'pointer',
                    display: 'inline-block',
                  }}
                  onClick={() =>
                    handleAddSubCategory({
                      tabId: parent[0],
                      catagory: parent[3],
                    })
                  }
                >
                  +
                </span>
                <span
                  className="cnslng-icn-bg right showTemplate"
                  title="Delete category"
                  style={{
                    padding: '0px 5px',
                    cursor: 'pointer',
                    display: 'inline-block',
                  }}
                  onClick={() => handleDeleteCategory(parent[0], parent[3])}
                >
                  x
                </span>
              </div>
            )}
          </span>
        </span>
        {/* {parent[0] === '1' && popupName === 'follow-up-counseling' && (
          <span>
            <span>ALL WNL</span>
            <input
              type="checkbox"
              id=""
              onClick={(e) => handleAllWnl(e, parent)}
            />
          </span>
        )} */}
      </span>
      <div
        style={{ backgroundColor: '#fff', marginLeft: '25px' }}
        className={accord === parent[3] ? '' : `${unHide}hide`}
        onClick={() => unHide && handleClick(parent[3])}
      >
        {parent[2]?.map((subData, s) => (
          <div
            key={s}
            className={
              classFirstCol === parent[3] + '_' + subData[0]
                ? 'prnt-chld-sec parnt-actv-tb'
                : 'prnt-chld-sec'
            }
            onClick={() => handleSubDataShow(parent[3] + '_' + subData[0])}
          >
            <div
              className={'mat-cnslng-prnt-val ' + moduleName}
              id={moduleName + '_' + parent[3] + '_' + subData[0]}
              value={parent[3] + '_' + subData[0]}
            >
              <div>{subData[1]}</div>
              {parent[4] !== 'medication' && parent[4] !== 'diagnosis' && (
                <div className={editModeEnabled ? '' : 'hide'}>
                  <span
                    className="showTemplate"
                    style={{ padding: '0px 5px', display: 'inline-block' }}
                    onClick={() =>
                      handleEditSubCategory({
                        id: subData[0],
                        tabId: parent[0],
                        labelName: subData[1],
                        catagory: parent[3],
                      })
                    }
                  >
                    ✎
                  </span>
                  <span
                    className="showTemplate"
                    style={{ padding: '0px 5px', display: 'inline-block' }}
                    onClick={() =>
                      handleDeleteSubCategory(subData[0], parent[3])
                    }
                  >
                    X
                  </span>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
export default CounselingAccordion;
